<template>
  <div class="sport">
    <div class="sport-hat">
      <sport-icon-liga-white :name="sport.alias" />
      <div class="sport-name ellipsis" v-if="this.$i18n.locale === 'ru'">{{ sport.name_ru }}</div>
      <div class="sport-name ellipsis" v-if="this.$i18n.locale === 'en'">{{ sport.name_en }}</div>
      <div class="sport-name ellipsis" v-if="this.$i18n.locale === 'az'">{{ sport.name_az }}</div>
    </div>
    <div class="list">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import SportIconLigaWhite from '@/components/icons/SportIconLigaWhite'

export default {
  components: {
    SportIconLigaWhite
  },
  props: {
    sport: Object
  }
}
</script>

<style scoped>
.sport-hat { display: flex; }
.sport-icon-liga { margin-top: 8px; margin-left: 8px;  }
.sport-name { flex: 1; padding-right: 10px; margin-left: 5px; line-height: 40px; }
.list { background: rgba(255, 255, 255, .05); position: relative; }
</style>



// WEBPACK FOOTER //
// src/components/header/SearchSport.vue